import React from 'react';
import Alert from '@material-ui/lab/Alert';
import styled from 'styled-components';

const StyledAlert = styled(Alert)`
  && {
    padding: 2px 14px;
    .MuiAlert-message {
      font-size: 12px;
      padding: 10px 0;
    }
  }
`;

const ErrorMessage = (props: { message: string }) => {
  return <StyledAlert severity="error">{props.message}</StyledAlert>;
};

export default ErrorMessage;
